import React, { useEffect, useState } from 'react';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { useRouterContext } from '../../hooks/use-router-context.js';
import { DependencyList } from './components/dependency-list.js';
import './manifest-dependencies.css';
const MANIFEST_URL = '/manifest.json';
function ManifestDependencies(props) {
    const [dependencies, setDependencies] = useState([]);
    const [version, setVersion] = useState('');
    const [href] = useRouterContext(MANIFEST_URL);
    const onGetSuccess = (response) => {
        const { dependencies, version } = response.body ?? {};
        setDependencies(dependencies ?? []);
        setVersion(version ?? '');
    };
    useEffect(() => {
        void HttpService.get(MANIFEST_URL)
            .then(onGetSuccess);
    }, [href]);
    return (React.createElement("div", { className: "c-manifest-dependencies" },
        React.createElement("div", { className: "c-manifest-dependencies__content" },
            React.createElement("div", { className: "c-manifest-dependencies__header" },
                React.createElement("div", { className: "c-manifest-dependencies__text c-manifest-dependencies__name" }, MessageService.translate(props.applicationName)),
                React.createElement("div", { className: "c-manifest-dependencies__text c-manifest-dependencies__version" }, MessageService.translate('tws.manifest-dependencies.version', { version }))),
            React.createElement(DependencyList, { dependencies: dependencies }))));
}
export { ManifestDependencies, };
//# sourceMappingURL=manifest-dependencies.js.map